import { createBrowserClient } from '@supabase/ssr';
import { Database } from '@tralent/database';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

export const supabaseClient = createBrowserClient<Database>(
	supabaseUrl!,
	supabaseKey!,
	{
		global: {
			headers: { 'x-tralent-app': 'web' },
		},
	},
);

export const client = supabaseClient;

export async function getAuthSession() {
	try {
		const session = await client.auth.getSession();
		return session.data.session;
	} catch (error) {
		console.log('User Warning ', error);
		return null;
	}
}

